/**
 * Checks whether an element is visible
 */
export const isVisible = (element: HTMLElement) => {
  if (!(element instanceof Element)) {
    throw Error('You must provide a DOM element.');
  }
  return (
    !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length) &&
    window.getComputedStyle(element).visibility !== 'hidden' &&
    window.getComputedStyle(element).display !== 'none' &&
    element.style?.transform.includes('translateY(-9999px)') === false
  );
};

/**
 * Return the previous/next element of a list.
 */
export const getNextActiveElement = (
  list: HTMLElement[],
  activeElement: HTMLElement | null | undefined,
  shouldGetNext: boolean,
  isCycleAllowed: boolean
) => {
  const listLength = list.length;
  let index = activeElement ? list.indexOf(activeElement) : -1;

  if (index === -1) {
    return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
  }

  index += shouldGetNext ? 1 : -1;

  if (isCycleAllowed) {
    index = (index + listLength) % listLength;
  }

  return list[Math.max(0, Math.min(index, listLength - 1))];
};

export const isElement = (el: unknown): el is HTMLElement => {
  return typeof el === 'object' && el !== null && 'tagName' in el && el instanceof HTMLElement;
};

/**
 * Returns the element to anchor a floating pane to: the element itself, or an event's current target.
 * Read it while the event is being handled, since `currentTarget` is cleared after dispatch.
 */
export const getAnchorElement = (trigger: HTMLElement | Event): HTMLElement | null => {
  const el = trigger instanceof Event ? trigger.currentTarget : trigger;
  return isElement(el) ? el : null;
};
